import React from "react";
import { I } from "services/lang/LanguageService";
import SeparatorImg from "public/images/separator.svg";
import { ISeparatorProps } from "./SeparatorTypes";

export default function Separator(props: ISeparatorProps) {
  return (
    <div>
      {!props.displayDweenLine ? (
        <h2 className="text-center">{I(props.title ?? "")}</h2>
      ) : (
        <img src={SeparatorImg} alt="separator" style={{ width: "100%" }} />
      )}
    </div>
  );
}
